import type {
	AdminBanUserByIdInput,
	AdminBanUsersInput,
	AdminGetManualTransactionFacetsInput,
	AdminGetManualTransactionsInput,
	AdminResetPasswordInput,
	AdminUnbanUserByIdInput,
	AdminUnbanUsersInput,
	AdminUpdateFcUserManualTransactionInput,
	adminUpdateFcUserInput,
	getAdminFcUsersInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface KeyTypes {
	useGetAdminFcUsers: getAdminFcUsersInput;
	useAdminUpdateFcUser: adminUpdateFcUserInput;
	useAdminUpdateFcUserManualTransaction: AdminUpdateFcUserManualTransactionInput;
	useAdminUserResetPassword: AdminResetPasswordInput;
	useGetManualTransactions: AdminGetManualTransactionsInput;
	useGetManualTransactionFacets: AdminGetManualTransactionFacetsInput;
	useAdminBanUsers: AdminBanUsersInput;
	useAdminUnbanUsers: AdminUnbanUsersInput;
	useAdminBanUserById: AdminBanUserByIdInput;
	useAdminUnbanUserById: AdminUnbanUserByIdInput;
	useGetAdminSenderGroups: undefined;
}

const ADMIN_FC_USERS_SERVICE_KEYS = createReactQueryKeys<KeyTypes>(
	"admin-fc-users",
	[
		"useGetAdminFcUsers",
		"useAdminUpdateFcUser",
		"useAdminUpdateFcUserManualTransaction",
		"useAdminUserResetPassword",
		"useGetManualTransactions",
		"useGetManualTransactionFacets",
		"useAdminBanUsers",
		"useAdminUnbanUsers",
		"useAdminBanUserById",
		"useAdminUnbanUserById",
		"useGetAdminSenderGroups",
	],
);

export { ADMIN_FC_USERS_SERVICE_KEYS };
